import { routes } from "Library/Constants";
import images from "../../Assets/images";
import icons from "Assets/images/icons";

export const GLOBAL_VARIABLES_TAB_ID = 8;

const tabs = [
  {
    id: 1,
    name: "Projects",
    image: images.ProjectIcon,
    Icon: icons.Projects,
    url: routes.dashboardNav.projects(),
    active: true,
  },
  {
    id: 2,
    name: "Organizations",
    image: images.OrganizationIcon,
    Icon: icons.BuildingBusinessOffice,
    url: routes.dashboardNav.organizations(),
    active: false,
  },
  {
    id: 3,
    name: "roles",
    image: images.UsersIcon,
    Icon: icons.Guard,
    url: routes.dashboardNav.roles(),
    active: false,
  },
  {
    id: 4,
    name: "users",
    image: images.UsersIcon,
    Icon: icons.PeopleThree,
    url: routes.dashboardNav.users(),
    active: false,
  },
  {
    id: 5,
    name: "platforms",
    image: images.companySetting,
    Icon: icons.Component,
    url: routes.dashboardNav.platforms(),
    active: false,
  },
  {
    id: 6,
    name: "webhooks",
    image: images.companySetting,
    Icon: icons.WorldNet,
    url: routes.dashboardNav.webhooks(),
    active: false,
  },
  {
  id: 7,
  name: "global_masters",
  Icon: icons.Component,
  url: "#",
  subTabs: [
    {
      id: "7-1",
      name: "equipment_master",
      url: routes.dashboardNav.equipmentMaster(),
    },
    {
      id: "7-2",
      name: "vehicle_master",
      url: routes.dashboardNav.vehicleMaster(),
    },
    {
      id: "7-3",
      name: "system_banners",
      url: routes.dashboardNav.systemBanners(),
    },
  ],
},
{
  // BUGS-504: Voyage Control global admins only, see Leftbar.
  id: GLOBAL_VARIABLES_TAB_ID,
  name: "global_variables",
  Icon: icons.Key,
  url: "#",
  subTabs: [
    {
      id: "8-1",
      name: "anthropic_model",
      url: routes.dashboardNav.anthropicModel(),
    },
    {
      id: "8-2",
      name: "anthropic_key",
      url: routes.dashboardNav.anthropicKey(),
    },
    {
      id: "8-3",
      name: "inventory_ledger_alerts",
      url: routes.dashboardNav.inventoryLedgerAlerts(),
    },
  ],
}

];
export const bottomtabs = [
  {
    id: 1,
    name: "Company Settings",
    image: images.companySetting,
    url: "",
  },
];
export const languageOptions = [
  { value: "English US", label: "English US" },
  { value: "English UK", label: "English UK" },
];
export default tabs;
